<template>
    <!-- contents -->
    <div>
        <!---->
        <div class="sub_tit mt25">{{ $t('FIELD.GLOBAL.BASIC.INFO') }}</div>
        <!-- //Basic Info head -->
        <!-- detail_Basic Info -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        {{ $t('FIELD.FAQ.CORP') }}
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td data-input-type="select">
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select class="slt_white w100p" v-model="rhqCd" @change="changeRhqCd()" :disabled="viewMode">
                                    <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p" v-model="corpNo" :disabled="viewMode">
                                    <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{ code.codeName }}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                    <th>{{$t('FIELD.GLOBAL.ID')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" ref="authId" v-model="authId" :disabled="viewMode" 
                                   maxlength="20" v-clearable />
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.GLOBAL.ROLE.NAME')}}<em class="txt_mandatory">*</em></th>
                    <td colspan="3">
                        <span class="clearable">
                            <input type="text" class="text_input w100" ref="authNm" v-model="authNm" maxlength="166" v-clearable />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('SUBTITLE.GLOBAL.DESCRIPTION') }}</th>
                    <td colspan="3">
                        <textarea class="text_textarea w100" v-model="authDesc" maxlength="1300"></textarea>
                    </td>
                </tr>
                <tr>
                    <th>
                        {{ $t('FIELD.GLOBAL.USE.STATUS') }}
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td colspan="3">
                        <select class="slt_white input-58" v-model="useYn">
                            <option value="Y" selected>{{ $t('FIELD.GLOBAL.YES') }}</option>
                            <option value="N">{{ $t('FIELD.GLOBAL.NO') }}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- page btn -->
        <div class="btn_wrap_full topLine">
            <a href="JavaScript:" v-if="!viewMode" class="btn_white" @click="goRoleList()" title>
                {{ $t('BUTTON.GLOBAL.LIST') }}
            </a>
            <div class="btn_right" v-if="this.sysAdmYn == 'Y'">
                <a href="JavaScript:" class="btn_white" @click="roleDelete()" title>{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                <a href="JavaScript:" class="btn_blue" @click="roleSave()" title>{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
            </div>
        </div>
        <!-- //page btn : -->
        <!-- //detail_Basic Info -->
        <!-- Authorization tit -->
        <div class="sub_tit mt25 w100" v-if="viewMode">{{ $t('FIELD.AUTHREQ.AUTH') }}</div>
        <!-- //Authorization tit -->

        <!-- //Authorization tab -->
        <div class="tab_wrap" v-if="viewMode">
            <ul class="tab_menu_02 tab_menus">
                <li :class="{ on: tabMode === 1 }">
                    <a href="JavaScript:" @click="changeTab(1)">{{ $t('FIELD.GLOBAL.MENU') }}</a>
                </li>
                <li :class="{ on: tabMode === 2 }">
                    <a href="JavaScript:" @click="changeTab(2)">{{ $t('FIELD.GLOBAL.PRODUCT.CATEGORY') }}</a>
                </li>
                <li :class="{ on: tabMode === 3 }">
                    <a href="JavaScript:" @click="changeTab(3)">{{ $t('FIELD.GLOBAL.USER') }} <em>({{authUsers.length | numberFormat}})</em></a>
                </li>
            </ul>
            <div class="tab_contents_list">
                <!-- Menu Tab -->
                <div class="tab_cont" v-if="tabMode == 1">
                    <dl class="tree_wrap noLine pl10">
                        <!-- search_tree 추가 -->
                        <dd>
                            <article class="tree_group">
                                <ul class="tree_list">
                                    <li v-for="menu1 in menuAllTrees" :key="menu1.MENUID">
                                        <a href="javascript:" class="ico_tree" v-if="menu1.subMenu" @click="treeClick($event, menu1.MENUID)" >
                                            <span class="sr_only"></span>
                                        </a>
                                        <label class="checkbox-wrap">
                                            <input type="checkbox" :name="'menu-' + menu1.MENUPARENTID + '-' + menu1.MENUID" class="chk"
                                                    :value="menu1.MENUID" :checked="'Y' === menu1.MENUCHECK ? true : false"
                                                    @change="treeMenuChange($event, menu1.MENUID)" />
                                            <i class="check-icon"></i>
                                            <em>{{ menu1.MENUNAME }}</em>
                                        </label>
                                        <label class="checkbox-wrap">
                                            (
                                            <input
                                                type="checkbox"
                                                :name="'read-' + menu1.MENUPARENTID + '-' + menu1.MENUID"
                                                class="chk"
                                                :value="menu1.MENUID"
                                                :disabled="'Y' === menu1.MENUCHECK ? false : true"
                                                :checked="'Y' === menu1.CREATIONCHECK ? true : false"
                                                @change="treeReadChange($event, menu1.MENUID)"
                                            />
                                            <i class="check-icon"></i>
                                            <em>{{ $t('FIELD.GLOBAL.CREATION') }}}</em> )
                                        </label>

                                        <ul class="tree_sub_list">
                                            <li v-for="menu2 in menu1.subMenu" :key="menu2.MENUID">
                                                <a
                                                    href="javascript:"
                                                    class="ico_tree"
                                                    v-if="menu2.subMenu"
                                                    @click="treeClick($event, menu2.MENUID)"
                                                >
                                                    <span class="sr_only"></span>
                                                </a>
                                                <label class="checkbox-wrap">
                                                    <input
                                                        type="checkbox"
                                                        :name="
                                                            'menu-' +
                                                                menu1.MENUPARENTID +
                                                                '-' +
                                                                menu2.MENUPARENTID +
                                                                '-' +
                                                                menu2.MENUID
                                                        "
                                                        class="chk"
                                                        :value="menu2.MENUID"
                                                        :checked="'Y' === menu2.MENUCHECK ? true : false"
                                                        @change="treeMenuChange($event, menu2.MENUID)"
                                                    />
                                                    <i class="check-icon"></i>
                                                    <em>{{ menu2.MENUNAME }}</em>
                                                </label>
                                                <label class="checkbox-wrap">
                                                    (
                                                    <input
                                                        type="checkbox"
                                                        :name="
                                                            'read-' +
                                                                menu1.MENUPARENTID +
                                                                '-' +
                                                                menu2.MENUPARENTID +
                                                                '-' +
                                                                menu2.MENUID
                                                        "
                                                        class="chk"
                                                        :value="menu2.MENUID"
                                                        :disabled="'Y' === menu2.MENUCHECK ? false : true"
                                                        :checked="'Y' === menu2.CREATIONCHECK ? true : false"
                                                        @change="treeReadChange($event, menu2.MENUID)"
                                                    />
                                                    <i class="check-icon"></i>
                                                    <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                                </label>
                                                <ul class="tree_sub_list">
                                                    <li v-for="menu3 in menu2.subMenu" :key="menu3.MENUID">
                                                        <a
                                                            href="javascript:"
                                                            class="ico_tree"
                                                            v-if="menu3.subMenu"
                                                            @click="treeClick($event, menu3.MENUID)"
                                                        >
                                                            <span class="sr_only"></span>
                                                        </a>
                                                        <label class="checkbox-wrap">
                                                            <input
                                                                type="checkbox"
                                                                :name="
                                                                    'menu-' +
                                                                        menu1.MENUPARENTID +
                                                                        '-' +
                                                                        menu2.MENUPARENTID +
                                                                        '-' +
                                                                        menu3.MENUPARENTID +
                                                                        '-' +
                                                                        menu3.MENUID
                                                                "
                                                                class="chk"
                                                                :value="menu3.MENUID"
                                                                :checked="'Y' === menu3.MENUCHECK ? true : false"
                                                                @change="treeMenuChange($event, menu3.MENUID)"
                                                            />
                                                            <i class="check-icon"></i>
                                                            <em>{{ menu3.MENUNAME }}</em>
                                                        </label>
                                                        <label class="checkbox-wrap">
                                                            (
                                                            <input
                                                                type="checkbox"
                                                                :name="
                                                                    'read-' +
                                                                        menu1.MENUPARENTID +
                                                                        '-' +
                                                                        menu2.MENUPARENTID +
                                                                        '-' +
                                                                        menu3.MENUPARENTID +
                                                                        '-' +
                                                                        menu3.MENUID
                                                                "
                                                                class="chk"
                                                                :value="menu3.MENUID"
                                                                :disabled="'Y' === menu3.MENUCHECK ? false : true"
                                                                :checked="'Y' === menu3.CREATIONCHECK ? true : false"
                                                                @change="treeReadChange($event, menu3.MENUID)"
                                                            />
                                                            <i class="check-icon"></i>
                                                            <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                                        </label>
                                                        <ul class="tree_sub_list">
                                                            <li v-for="menu4 in menu3.subMenu" :key="menu4.MENUID">
                                                                <a
                                                                    href="javascript:"
                                                                    class="ico_tree"
                                                                    v-if="menu4.subMenu"
                                                                    @click="treeClick($event, menu4.MENUID)"
                                                                >
                                                                    <span class="sr_only"></span>
                                                                </a>
                                                                <label class="checkbox-wrap">
                                                                    <input
                                                                        type="checkbox"
                                                                        :name="
                                                                            'menu-' +
                                                                                menu1.MENUPARENTID +
                                                                                '-' +
                                                                                menu2.MENUPARENTID +
                                                                                '-' +
                                                                                menu3.MENUPARENTID +
                                                                                '-' +
                                                                                menu4.MENUPARENTID +
                                                                                '-' +
                                                                                menu4.MENUID
                                                                        "
                                                                        class="chk"
                                                                        :value="menu4.MENUID"
                                                                        :checked="
                                                                            'Y' === menu4.MENUCHECK ? true : false
                                                                        "
                                                                        @change="treeMenuChange($event, menu4.MENUID)"
                                                                    />
                                                                    <i class="check-icon"></i>
                                                                    <em>{{ menu4.MENUNAME }}</em>
                                                                </label>
                                                                <label class="checkbox-wrap">
                                                                    (
                                                                    <input
                                                                        type="checkbox"
                                                                        :name="
                                                                            'read-' +
                                                                                menu1.MENUPARENTID +
                                                                                '-' +
                                                                                menu2.MENUPARENTID +
                                                                                '-' +
                                                                                menu3.MENUPARENTID +
                                                                                '-' +
                                                                                menu4.MENUPARENTID +
                                                                                '-' +
                                                                                menu4.MENUID
                                                                        "
                                                                        class="chk"
                                                                        :value="menu4.MENUID"
                                                                        :disabled="
                                                                            'Y' === menu4.MENUCHECK ? false : true
                                                                        "
                                                                        :checked="
                                                                            'Y' === menu4.CREATIONCHECK ? true : false
                                                                        "
                                                                        @change="treeReadChange($event, menu4.MENUID)"
                                                                    />
                                                                    <i class="check-icon"></i>
                                                                    <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                                                </label>
                                                                <ul class="tree_sub_list">
                                                                    <li
                                                                        v-for="menu5 in menu4.subMenu"
                                                                        :key="menu5.MENUID"
                                                                    >
                                                                        <a
                                                                            href="javascript:"
                                                                            class="ico_tree"
                                                                            v-if="menu5.subMenu"
                                                                            @click="treeClick($event, menu5.MENUID)"
                                                                        >
                                                                            <span class="sr_only"></span>
                                                                        </a>
                                                                        <label class="checkbox-wrap">
                                                                            <input
                                                                                type="checkbox"
                                                                                :name="
                                                                                    'menu-' +
                                                                                        menu1.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu2.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu3.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu4.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu5.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu5.MENUID
                                                                                "
                                                                                class="chk"
                                                                                :value="menu5.MENUID"
                                                                                :checked="
                                                                                    'Y' === menu5.MENUCHECK
                                                                                        ? true
                                                                                        : false
                                                                                "
                                                                                @change="
                                                                                    treeMenuChange($event, menu5.MENUID)
                                                                                "
                                                                            />
                                                                            <i class="check-icon"></i>
                                                                            <em>{{ menu5.MENUNAME }}</em>
                                                                        </label>
                                                                        <label class="checkbox-wrap">
                                                                            (
                                                                            <input
                                                                                type="checkbox"
                                                                                :name="
                                                                                    'read-' +
                                                                                        menu1.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu2.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu3.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu4.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu5.MENUPARENTID +
                                                                                        '-' +
                                                                                        menu5.MENUID
                                                                                "
                                                                                class="chk"
                                                                                :value="menu5.MENUID"
                                                                                :disabled="
                                                                                    'Y' === menu5.MENUCHECK
                                                                                        ? false
                                                                                        : true
                                                                                "
                                                                                :checked="
                                                                                    'Y' === menu5.CREATIONCHECK
                                                                                        ? true
                                                                                        : false
                                                                                "
                                                                                @change="
                                                                                    treeReadChange($event, menu5.MENUID)
                                                                                "
                                                                            />
                                                                            <i class="check-icon"></i>
                                                                            <em>{{ $t('FIELD.GLOBAL.CREATION') }}}</em>
                                                                            )
                                                                        </label>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </article>
                        </dd>
                    </dl>
                    <!-- page btn -->
                    <div class="btn_wrap_full topLine">
                        <a href="JavaScript:" class="btn_white" @click="goRoleList()" title>
                            {{ $t('BUTTON.GLOBAL.LIST') }}
                        </a>
                        <div class="btn_right" v-if="this.sysAdmYn == 'Y'">
                            <a href="JavaScript:" class="btn_blue" @click="menuSave()" title>
                                {{ $t('BUTTON.GLOBAL.SAVE') }}
                            </a>
                        </div>
                    </div>
                </div>
                <!-- Product Tab -->
                <div class="tab_cont" v-if="tabMode == 2">
                    <table class="scroll_table">
                        <colgroup>
                            <col width="7%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <th width="7%">
                                <label class="checkbox-wrap">
                                    <input type="checkbox" v-model="selectAllCate" @change="checkAllCate()" />
                                    <i class="check-icon"></i>
                                </label>
                            </th>
                            <th width="25%">{{ $t('FIELD.GLOBAL.DEPTH1') }}</th>
                            <th width="25%">{{ $t('FIELD.GLOBAL.DEPTH2') }}</th>
                            <th width="*">{{ $t('FIELD.GLOBAL.DEPTH3') }}</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in categories" :key="item.CATEGORYID">
                                <td class="tC" width="7%">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" v-model="item.selected" />
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <td class="tC" width="25%">{{item.PRDCATEGORY1NAME}}</td>
                                <td class="tC" width="25%">{{item.PRDCATEGORY2NAME}}</td>
                                <td class="tC" width="*">{{item.PRDCATEGORY3NAME}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- page btn -->
                    <div class="btn_wrap_full">
                        <a href="JavaScript:" class="btn_white" @click="goRoleList()" title>
                            {{ $t('BUTTON.GLOBAL.LIST') }}
                        </a>
                        <div class="btn_right">
                            <a href="JavaScript:" class="btn_white" @click="cateDelete()" title>
                                {{ $t('BUTTON.GLOBAL.DELETE') }}
                            </a>
                            <a href="JavaScript:" class="btn_blue" @click="cateAdd()" title>
                                {{ $t('BUTTON.GLOBAL.ADD') }}
                            </a>
                        </div>
                    </div>
                </div>
                <!-- User Tab -->
                <div class="tab_cont" v-if="tabMode == 3">
                    <div class="grid_wrap mt-10">
                        <toast-grid
                            :gridId="gridId"
                            :columns="columns"
                            :data="authUsers"
                            :options="options"
                            :ref="gridId"
                            :key="gridKey"
                            :pageOptions="pageOptions"
                            :isTotalCount="false"
                            :click="contentClick"
                        />
                    </div>
<!--                <table class="scroll_table">
                        <colgroup>
                            <col width="7%" />
                            <col width="20%" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <th width="7%">
                                <label class="checkbox-wrap">
                                    <input type="checkbox" v-model="selectAllUser" @change="checkAllUser()" />
                                    <i class="check-icon"></i>
                                </label>
                            </th>
                            <th width="20%">{{ $t('FIELD.GLOBAL.ID') }}</th>
                            <th width="*">{{ $t('FIELD.ADMIN.NAME') }}</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in authUsers" :key="item.LOGINID">
                                <td class="tC" width="7%">
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" v-model="item.selected" />
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <td class="tC" width="20%">{{ item.LOGINID }}</td>
                                <td class="tC" width="*">{{ item.LOGINNM }}</td>
                            </tr>
                        </tbody>
                    </table>
-->                    
                    <!-- page btn -->
                    <div class="btn_wrap_full">
                        <a href="JavaScript:" class="btn_white" @click="goRoleList()" title>
                            {{ $t('BUTTON.GLOBAL.LIST') }}
                        </a>
                        <div class="btn_right">
                            <a href="JavaScript:" class="btn_white" @click="userDelete()" title>
                                {{ $t('BUTTON.GLOBAL.DELETE') }}
                            </a>
                            <a href="JavaScript:" class="btn_blue" @click="userAdd()" title>
                                {{ $t('BUTTON.GLOBAL.ADD') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- //Authorization tab -->
    </div>
    <!-- //Label Setting list -->
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import UserAddPopup from './UserAddPopup';
import CateAddPopup from './CategoryAddPopup';
import { mapGetters } from 'vuex';
import api from '@/service';
import ToastGrid from '~c/ToastGrid';

let DELETE_ITEMS = [];
// Toast Grid Custom Renderer
class CheckButtonType {
    constructor(props) {
        let rowKey = props.rowKey;
        let loginNo = props.grid.store.data.rawData[rowKey].LOGINNO;
        const el = document.createElement('input');
        el.setAttribute('type', 'checkbox');
        el.setAttribute('name', 'checkbox');
        el.classList.add('check-icon');
        if (DELETE_ITEMS.length > 0 && DELETE_ITEMS.indexOf(loginNo) > -1) {
            el.checked = true;
        }
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'ResrcAdminDetail',
    props: {
        pRhqCdList: { type: Array, default: [] },
        pCorpNoList: { type: Array, default: [] },
        pAuthCorpId: { type: String, default: '' },
    },
    data() {
        return {
            isLoading: true,
            viewMode: false, // 'create or modify'
            authCorpId: this.pAuthCorpId,
            authId: '',
            authNm: '',
            authDesc: '',
            useYn: '',
            rhqCd: '',
            corpNo: '',
            tabMode: 1,
            rhqCdList: [],
            corpNoList: [],
            selectAllCate: '',
            selectAllUser: '',
            menuAllTrees: [], // DB에서 읽어온 전체 메뉴 트리
            checkedMenuIds: [], // 체크된 메뉴 목록(저장시 필요)
            checkedCreations: [], // Creation이 체크된 메뉴 목록
            categories: [], // Product Category 탭에서 보이는 목록
            authUsers: [], // User 탭에서 보이는 목록
            deleteItems: [], // 체크된 삭제 목록
            gridId: 'authUserGrid',
            gridKey: 0,
            resultCount: 0,
            sysAdmYn:'',
            columns: [
                {
                    header: 'Check',
                    name: '',
                    align: 'center',
                    width: 70,
                    resizable: true,
                    sortable: false,
                    renderer: { type: CheckButtonType }
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LOGIN.ID'),
                    align: 'center',
                    name: 'LOGINID',
                    width: 250,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.SURVEY.SUMMARY.USER_NAME'),
                    name: 'LOGINNM',
                    align: 'center',
//                    width: 250,
                    sortable: true
                }
            ],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 318,
                rowHeight: 25,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 8,
            }
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        }
    },
    watch: {

    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(pCode, corpNo) {
            this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
                if (corpNo) this.corpNo = corpNo;
                else this.corpNo = data[0].code;
            });
        },
        initDataLoad() {
            SDLUtil.showLoadingBar(true);
            const param = { authCorpId: this.authCorpId, authId: this.authId, corpNo: this.corpNo };
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/system/userRole/roleAdminInfo.skp`, { params: param })
                .then(resp => {
                    let authInfo = resp.data.authInfo;
                    this.authId     = authInfo.authId;
                    this.authCorpId = authInfo.authCorpId;
                    this.authNm     = authInfo.authNm;
                    this.authDesc   = authInfo.authDesc;
                    this.useYn      = authInfo.useYn;
                    this.rhqCd      = authInfo.rhqCd;
                    this.corpNo     = authInfo.corpNo;
                    this.loadSubsiCodes(this.rhqCd, this.corpNo);

                    // this.menuAllTrees  = resp.data.menuTrees.rowData;
                    this.authUsers  = resp.data.users.rowData;
                    this.gridKey += 1;
                    this.categories = resp.data.categories.rowData;

                    let menuTree1 = [];
                    let menuTree2 = [];
                    let menuTree3 = [];
                    let menuTree4 = [];
                    let menuTree5 = [];

                    for (const menu of resp.data.menuTrees.rowData) {
                        if (1 === menu.MENULEVEL) {
                            menuTree1.push(menu);
                        } else if (2 === menu.MENULEVEL) {
                            menuTree2.push(menu);
                        } else if (3 === menu.MENULEVEL) {
                            menuTree3.push(menu);
                        } else if (4 === menu.MENULEVEL) {
                            menuTree4.push(menu);
                        } else if (5 === menu.MENULEVEL) {
                            menuTree5.push(menu);
                        }
                    }

                    menuTree4 = this.menuTreeMerge(menuTree4, menuTree5);
                    menuTree3 = this.menuTreeMerge(menuTree3, menuTree4);
                    menuTree2 = this.menuTreeMerge(menuTree2, menuTree3);
                    menuTree1 = this.menuTreeMerge(menuTree1, menuTree2);

                    this.menuAllTrees = menuTree1;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        menuTreeMerge(parent, cildren) {
            for (const menus of parent) {
                const addMenu = new Array();
                for (const subMenu of cildren) {
                    if (subMenu.MENUPARENTID === menus.MENUID) {
                        addMenu.push(subMenu);
                    }
                }
                if (0 < addMenu.length) {
                    menus.subMenu = addMenu;
                }
            }
            return parent;
        },
        // aftMode: 1=goRoleList, 2=refresh
        saveExec(url, formData, msg, aftMode) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.result == 1) { // 저장 시...
                        this.viewMode = true;
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        if (aftMode == 1) { // Role 메인 삭제 시..
                            EventBus.$emit('goRoleList', 1);
                        } else if (aftMode == 3) { // Role 메인 저장 시..
                            this.initDataLoad();
                        }
                    } else if (resp.data.result == 2) {
                        SDLUtil.alert('TITLE.PERSONALIZE.AUTH.REQUEST');
                    } else {
                        SDLUtil.alert('Error occured ' + resp.data.result);
                    }
                })
                .catch(err => {
                    this.searchStatus = 'error';
                    SDLUtil.showLoadingBar(false);
                });
        },
        authValidateion() {
            let bRes = true;
            let valids = [this.authId, this.authNm, this.useYn, this.rhqCd, this.corpNo];
            let titles = ['ID', 'Role Name', 'Use Status', 'Subsidiary1', 'Subsidiary2'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        saveParams(exclude = []) {
            let params = {
                updateMode: this.viewMode,
                authCorpId: this.authCorpId,
                corpNo: this.corpNo,
                authId: this.authId,
                authNm: this.authNm,
                authDesc: this.authDesc,
                useYn: this.useYn,
            };
            return params;
        },
        preMenuSaveParams() {
            this.checkedMenuIds = []; // 체크된 메뉴 목록(저장시 필요)
            this.checkedCreations = []; // Creation이 체크된 메뉴 목록
            this.getCheckMenus().forEach(elm => {
                if (elm.MENUCHECK == 'Y') {
                    this.checkedMenuIds.push(elm.MENUID);
                    if (elm.CREATIONCHECK == 'Y') {
                        this.checkedCreations.push(elm.MENUID);
                    }
                }
            });
        },
        // 메뉴 탭에서 [Save] 버튼 클릭 시...
        menuSave() {
            this.preMenuSaveParams();

            const param = {
                authCorpId: this.authCorpId,
                authId: this.authId,
                corpNo : this.corpNo,
                userMenus: this.checkedMenuIds,
                creations: this.checkedCreations,
            }; //
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    const url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleMenuSave.skp`;
                    this.saveExec(url, param, 'MESSAGE.SUCCESS.SAVED', 0);
                },
            });
        },
        // Main Save 버튼 클릭...
        roleSave() {
            const fData = this.saveParams();
            //console.log('this.authValidateion() ==> ', this.authValidateion());
            if (!this.authValidateion()) {
                return;
            }
            //console.log('save.fData ==> ', fData);
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleAdminSave.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.SAVED', 3);
                },
            });
        },
        // Main Delete 버튼 클릭...
        roleDelete() {
            const fData = { authCorpId: this.authCorpId };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleAdminDelete.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.DELETED', 1);
                },
            });
        },
        changeRhqCd() {
            this.loadSubsiCodes(this.rhqCd);
        },
        changeTab(mode) {
            this.tabMode = mode;
        },
        checkAllCate() {
            this.categories.forEach(item => {
                item.selected = this.selectAllCate;
            });
        },
        checkAllUser() {
            this.authUsers.forEach(item => {
                item.selected = this.selectAllUser;
            });
        },
        goRoleList() {
            EventBus.$emit('goRoleList', 1);
        },
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                // $('.tree_list > li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        treeMenuChange(e, v) {
            let name = $(e.target).prop('name');
            let parentNames = $(e.target)
                .prop('name')
                .split('-');
            if ($(e.target).is(':checked')) {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', true);
                });

                let parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target;
                    $('input[name=' + parentName + ']').prop('checked', true);
                });

                name = name.replace('menu-', 'read-');
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('disabled', false);
                });

                parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target.replace('menu-', 'read-');
                    $('input[name=' + parentName + ']').prop('disabled', false);
                });
            } else {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                });

                for (let i = parentNames.length; 0 < i; i--) {
                    let parentName = '';
                    let cnt = 0;

                    for (let index = 0; index < i; index++) {
                        parentName += parentNames[index] + '-';
                    }

                    $('input[name*=' + parentName + ']').each(function(idx) {
                        if ($(this).is(':checked')) {
                            cnt++;
                        }
                    });

                    if (0 === cnt) {
                        $('input[name=' + parentName.substring(0, parentName.length - 1) + ']').prop('checked', false);
                        $(
                            'input[name=' +
                                parentName.replace('menu-', 'read-').substring(0, parentName.length - 1) +
                                ']',
                        ).prop('checked', false);
                    }
                }

                name = name.replace('menu-', 'read-');
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                    $(this).prop('disabled', true);
                });
            }
        },
        treeReadChange(e, v) {
            let name = $(e.target).prop('name');
            let parentNames = $(e.target)
                .prop('name')
                .split('-');
            if ($(e.target).is(':checked')) {
                $('input[name*=' + name + ']').each(function(idx) {
                    if (!$(this).is(':disabled')) {
                        $(this).prop('checked', true);
                    }
                });

                let parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target;
                    $('input[name=' + parentName + ']').prop('checked', true);
                });
            } else {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                });

                for (let i = parentNames.length; 0 < i; i--) {
                    let parentName = '';
                    let cnt = 0;

                    for (let index = 0; index < i; index++) {
                        parentName += parentNames[index] + '-';
                    }

                    $('input[name*=' + parentName + ']').each(function(idx) {
                        if ($(this).is(':checked')) {
                            cnt++;
                        }
                    });

                    if (0 === cnt) {
                        $('input[name=' + parentName.substring(0, parentName.length - 1) + ']').prop('checked', false);
                    }
                }
            }
        },
        isDisabled(v) {
            return !$('input[name=' + v.replace('read', 'menu') + ']').is(':checked');
        },
        getCheckMenus() {
            const checkMenus = new Array();
            $('input[name*=menu-]').each(function(idx) {
                if ($(this).is(':checked')) {
                    if (
                        $(
                            'input[name=' +
                                $(this)
                                    .prop('name')
                                    .replace('menu', 'read') +
                                ']',
                        ).is(':checked')
                    ) {
                        checkMenus.push({ MENUID: $(this).val(), MENUCHECK: 'Y', CREATIONCHECK: 'Y' });
                    } else {
                        checkMenus.push({ MENUID: $(this).val(), MENUCHECK: 'Y', CREATIONCHECK: '' });
                    }
                } else {
                    checkMenus.push({ MENUID: $(this).val(), MENUCHECK: 'N', CREATIONCHECK: '' });
                }
            });
            //            console.log('checkMenus  ==> ', checkMenus);
            return checkMenus;
        },
        cateAddSave(cateList) {
            let saveCateList = []; // ["p1", "p2", "p3"]
            cateList.forEach(elm => {
                saveCateList.push(elm.PROD_CD);
            });

            let url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleCatePopupSave.skp`;
            let param = { authCorpId: this.authCorpId, categories: saveCateList };
            this.saveExec(url, param, 'MESSAGE.SUCCESS.SAVED', 2);
        },
        cateAdd() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                CateAddPopup,
                {
                    title: 'Product Category Search',
                    isConfirm: true,
                    rtnFunc: cateList => {
                        this.cateAddSave(cateList);
                        this.initDataLoad();
                    },
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        cateDelete() {
            // 체크된 항목 삭제
            this.deleteItems = [];
            this.categories.forEach(elm => {
                let chk = elm.selected;
                let prodCds = elm.PRDCATEGORYCD1 + '^' + elm.PRDCATEGORYCD2 + '^' + elm.PRDCATEGORYCD3;
                if (chk) this.deleteItems.push(prodCds);
            });
            //console.log('this.deleteItems ---> ', this.deleteItems);
            if (this.deleteItems.length < 1) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            }
            if (this.deleteItems.length == 1) this.deleteItems.push('0^0^0');

            let param = { authCorpId: this.authCorpId, delCateCodes: this.deleteItems };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleCateDelete.skp`;
                    this.saveExec(url, param, 'MESSAGE.SUCCESS.DELETED', 2);
                },
            });
        },
        // User Sace
        userAddSave(selectUsers) {
            let param = {authCorpId: this.authCorpId, authId: this.authId, loginList: selectUsers};
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/system/userRole/roleUsersSave.skp`,
                qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                },
            ).then(resp => {
                if (resp.data.result == 1) {
                    Vue.toasted.show(
                        SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                            theme: "toasted-primary",
                            position: "top-center",
                            duration : 3000
                        }
                    );

                    this.initDataLoad();
                } else if (resp.data.result == 2) {
                    SDLUtil.alert('TITLE.PERSONALIZE.AUTH.REQUEST');
                } else {
                    SDLUtil.alert('Error occured ' + resp.data.result);
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        userAdd() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                UserAddPopup,
                {
                    title: 'Search User',
                    pAuthCorpId: this.authCorpId,
                    pAuthId: this.authId,
                    pRhqCdList: this.rhqCdList,
                    pCorpNoList: this.corpNoList,
                    pMenuMode: false,
                    rtnUserFunc: (arg1) => {
                        let users = [];
                        arg1.forEach(elm => {
                            users.push(elm.split('^')[0]);
                        });
                        this.userAddSave(users);
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        goRoleList() {
            EventBus.$emit('goRoleList', 1);
        },
        userDelete() {
            // 체크된 항목 삭제
            if (DELETE_ITEMS.length < 1) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            }

            if (DELETE_ITEMS.length == 1) DELETE_ITEMS.push('0000');
            let param = { authCorpId: this.authCorpId, loginList: DELETE_ITEMS };
            //console.log('param ==> ', param);
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/userRole/roleUserDelete.skp`;
                    this.saveExec(url, param, 'MESSAGE.SUCCESS.DELETED', 2);
                },
            });
        },
        removeList(logino) {
            let newList = [];
            DELETE_ITEMS.forEach(elm => {
                if (logino != elm) {
                    newList.push(elm);
                }
            });
            DELETE_ITEMS = newList;
        },
        contentClick(e, rowData, grid) {
            let curRowKey = e.rowKey;
            if (curRowKey > this.pageOptions.perPage) {
                curRowKey = e.rowKey % this.pageOptions.perPage;
            }
            let loginNo = rowData[e.rowKey]['LOGINNO'];
//            let loginId = rowData[e.rowKey]['LOGINID'];
//            let loginNm = rowData[e.rowKey]['LOGINNM'];
//            const key = loginNo + '^' + loginId + '^' + loginNm;

            if ($('.check-icon')[curRowKey].checked) {
                DELETE_ITEMS.push(loginNo);
            } else {
                this.removeList(loginNo);
            }

            // console.log('contentClick',e.rowKey,curRowKey,$('.radio-icon')[curRowKey].checked,rowData[e.rowKey]['CDMODEL'],rowData[e.rowKey]['NMMODEL']);
        },
    }, // methods
    created() {
        this.rhqCdList;
        //        EventBus.$on('refresh', this.refresh);
        //        EventBus.$on('goList', this.goList);
    },
    mounted() {
        this.authCorpId = this.pAuthCorpId;
        this.rhqCdList = this.pRhqCdList;
        this.corpNoList = this.pCorpNoList;
        this.viewMode = this.pAuthCorpId ? true : false;
        if (this.viewMode) {
            // 상세 View 모드
            this.initDataLoad();
            this.$refs.authNm.focus();
        } else {
            // Create Mode
//          this.rhqCd = this.rhqCdList[0].code;
            this.rhqCd = '';
            this.corpNo = '';
            this.useYn = 'Y';
            this.$refs.authId.focus();
        }
        this.sysAdmYn = SDLUtil.isRoleExist(`${constants.SYSTEM_ADMIN}`) ? 'Y' : 'N' ;
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        //        EventBus.$off('refresh');
        //        EventBus.$off('goList');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/userRole/RoleAdminView.vue